{
  "contractVersion": 1,
  "generatedAt": "2026-01-01T00:00:00.000Z",
  "season": { "id": "season-2026-q1", "name": "Season 1", "dayNumber": 1 },
  "sides": {
    "beornings": { "totalPoints": 0, "sharePct": 50.0 },
    "lothwen": { "totalPoints": 0, "sharePct": 50.0 }
  },
  "world": { "treesChoppedTotal": 0, "treesPlantedTotal": 0 },
  "events": []
}
